const ROUTE_CHUNK_RELOAD_KEY = "muhaha:route-chunk-reload";

type ReloadStorage = Pick<Storage, "getItem" | "setItem" | "removeItem">;

/** Browser messages emitted when a hashed Vite route chunk disappeared during a rolling deploy. */
export function isDynamicImportFailure(error: unknown): boolean {
	const message = error instanceof Error ? error.message : String(error ?? "");
	return /failed to fetch dynamically imported module|importing a module script failed|error loading dynamically imported module|chunkloaderror|loading chunk \d+ failed/i.test(
		message,
	);
}

/**
 * Claim the one automatic reload allowed for a failed route import. The marker survives the reload,
 * preventing a missing/corrupt current chunk from creating an infinite refresh loop.
 */
export function prepareDynamicImportReload(error: unknown, storage: ReloadStorage): boolean {
	if (!isDynamicImportFailure(error)) return false;
	try {
		if (storage.getItem(ROUTE_CHUNK_RELOAD_KEY) === "1") return false;
		storage.setItem(ROUTE_CHUNK_RELOAD_KEY, "1");
		return true;
	} catch {
		// If sessionStorage is unavailable, fail normally rather than risk an unbounded reload loop.
		return false;
	}
}

/** A successful lazy import proves the current asset graph is healthy, so a future deploy may retry. */
export function clearDynamicImportReload(storage: ReloadStorage): void {
	try {
		storage.removeItem(ROUTE_CHUNK_RELOAD_KEY);
	} catch {
		// Storage access is best-effort (private modes/policies may reject it).
	}
}
